import React, { useState } from 'react';

const STORAGE_KEY = 'dev_gate_passed';

/**
 * DevGate - Optional password protection for dev/staging environments.
 *
 * Enable by setting REACT_APP_DEV_GATE_ENABLED=true and REACT_APP_DEV_GATE_PASSWORD.
 * For production: omit these env vars and the gate is bypassed (or remove this component).
 *
 * To remove entirely: delete this file and the <DevGate> wrapper in index.tsx.
 */
function DevGate({ children }: { children: React.ReactNode }) {
  const enabled = process.env.REACT_APP_DEV_GATE_ENABLED === 'true';
  const expectedPassword = process.env.REACT_APP_DEV_GATE_PASSWORD || 'dev';

  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  if (!enabled) {
    return <>{children}</>;
  }

  const passed = typeof window !== 'undefined' && sessionStorage.getItem(STORAGE_KEY) === '1';
  if (passed) {
    return <>{children}</>;
  }

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    if (password === expectedPassword) {
      sessionStorage.setItem(STORAGE_KEY, '1');
      window.location.reload(); // Simple way to re-render with gate passed
    } else {
      setError('Incorrect password');
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 dark:bg-gray-900 flex items-center justify-center p-4">
      <div className="bg-white dark:bg-gray-800 rounded-xl shadow-lg p-8 max-w-sm w-full">
        <h2 className="text-xl font-semibold text-gray-800 dark:text-gray-100 mb-2">
          Dev environment
        </h2>
        <p className="text-sm text-gray-600 dark:text-gray-400 mb-6">
          Enter the password to continue
        </p>
        <form onSubmit={handleSubmit}>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
            className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 placeholder-gray-500 focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            autoFocus
          />
          {error && (
            <p className="mt-2 text-sm text-red-600 dark:text-red-400">{error}</p>
          )}
          <button
            type="submit"
            className="mt-4 w-full py-2 px-4 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg transition-colors"
          >
            Enter
          </button>
        </form>
      </div>
    </div>
  );
}

export default DevGate;
